export const DEFAULT_LOCALE = 'fr_FR';

const getLangFromLocale = (locale?: string | null) => {
  return (locale || DEFAULT_LOCALE).slice(0, 2);
};

export default getLangFromLocale;
